/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCollapsibleIcon/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import Tysiav2ChevronDown from 'DesignSystem/Svgs/Tysiav2ChevronDown/index'
import Tysiav2ChevronUp from 'DesignSystem/Svgs/Tysiav2ChevronUp/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaCollapsibleIcon({
  children,
  viewPath = "/DesignSystem/TysiaCollapsible/TysiaCollapsibleIcon",
  isOpen
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<fromFlow.When is={isOpen}>
<Tysiav2ChevronUp
  viewPath={`${viewPath}/Tysiav2ChevronUp`}
 marginLeft="auto"
 fill={dtColorsNeutral400}
/>
</fromFlow.When>
<fromFlow.When is={!isOpen}>
<Tysiav2ChevronDown
  viewPath={`${viewPath}/Tysiav2ChevronDown`}
 marginLeft="auto"
 fill2={dtColorsNeutral400}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}